import React from 'react'
import LogoImage from "../../../mbh/styles/images/claridges-logo-colored.svg"
import MobileLogoImage from "../../../mbh/styles/images/claridges-logo-colored-mobile.svg"
import { useTranslation } from "react-i18next"

const CustomHeader = ({
  className = "column15"
}) => {

  const { t } = useTranslation()

  return (
    <div className={`${className} brandLogo`}>
      <a tabindex="0" aria-label={t("navigate_to_claridges")} className="dInlineBlock" id='siteLogo' href="https://www.claridges.co.uk/">
        <img className="desktopLogo" src={LogoImage} alt="claridges logo" width="175" height="71"/>
        <img className="mobileLogo" src={MobileLogoImage} alt="Mobile claridges logo" width="192" height="28"/>
      </a>
    </div>
  )
}

export default CustomHeader